export const support = {
  email: 'hiring@brighterly.com',
  landingUrl: 'https://brighterly.com/',
}